export const emojis = [
    // 😀 Smileys & Emotion
    { emoji: '😀', code: '&#128512;' },
    { emoji: '😁', code: '&#128513;' },
    { emoji: '😂', code: '&#128514;' },
    { emoji: '🤣', code: '&#129315;' },
    { emoji: '😃', code: '&#128515;' },
    { emoji: '😄', code: '&#128516;' },
    { emoji: '😅', code: '&#128517;' },
    { emoji: '😆', code: '&#128518;' },
    { emoji: '😉', code: '&#128521;' },
    { emoji: '😊', code: '&#128522;' },
    { emoji: '😋', code: '&#128523;' },
    { emoji: '😎', code: '&#128526;' },
    { emoji: '😍', code: '&#128525;' },
    { emoji: '😘', code: '&#128536;' },
    { emoji: '😗', code: '&#128535;' },
    { emoji: '😙', code: '&#128537;' },
    { emoji: '😚', code: '&#128538;' },
    { emoji: '🙂', code: '&#128578;' },
    { emoji: '🤗', code: '&#129303;' },
    { emoji: '🤔', code: '&#129300;' },
    { emoji: '😐', code: '&#128528;' },
    { emoji: '😶', code: '&#128566;' },
    { emoji: '🙄', code: '&#128580;' },
    { emoji: '😏', code: '&#128527;' },
    { emoji: '😣', code: '&#128547;' },
    { emoji: '😥', code: '&#128549;' },
    { emoji: '😮', code: '&#128558;' },
    { emoji: '🤐', code: '&#129296;' },
    { emoji: '😯', code: '&#128559;' },
    { emoji: '😪', code: '&#128554;' },
    { emoji: '😫', code: '&#128555;' },
    { emoji: '😴', code: '&#128564;' },
    { emoji: '😌', code: '&#128524;' },
    { emoji: '😛', code: '&#128539;' },
    { emoji: '😜', code: '&#128540;' },
    { emoji: '😝', code: '&#128541;' },
    { emoji: '🤤', code: '&#129316;' },
    { emoji: '😒', code: '&#128530;' },
    { emoji: '😓', code: '&#128531;' },
    { emoji: '😭', code: '&#128557;' },
    { emoji: '😡', code: '&#128545;' },
    { emoji: '🤬', code: '&#129324;' },

    // 👋 People & Body
    { emoji: '👋', code: '&#128075;' },
    { emoji: '🤚', code: '&#129306;' },
    { emoji: '🖐️', code: '&#128400;' },
    { emoji: '✋', code: '&#9995;' },
    { emoji: '🖖', code: '&#128406;' },
    { emoji: '👌', code: '&#128076;' },
    { emoji: '🤏', code: '&#129295;' },
    { emoji: '✌️', code: '&#9996;' },
    { emoji: '🤞', code: '&#129310;' },
    { emoji: '🤟', code: '&#129311;' },
    { emoji: '🤘', code: '&#129304;' },
    { emoji: '🤙', code: '&#129305;' },
    { emoji: '👈', code: '&#128072;' },
    { emoji: '👉', code: '&#128073;' },
    { emoji: '👆', code: '&#128070;' },
    { emoji: '👇', code: '&#128071;' },
    { emoji: '👍', code: '&#128077;' },
    { emoji: '👎', code: '&#128078;' },
    { emoji: '👏', code: '&#128079;' },
    { emoji: '🙌', code: '&#128588;' },
    { emoji: '👐', code: '&#128080;' },
    { emoji: '🙏', code: '&#128591;' },
    { emoji: '💪', code: '&#128170;' },
    { emoji: '🤝', code: '&#129309;' },

    // ❤️ Symbols
    { emoji: '❤️', code: '&#10084;' },
    { emoji: '🧡', code: '&#128997;' },
    { emoji: '💛', code: '&#128998;' },
    { emoji: '💚', code: '&#128999;' },
    { emoji: '💙', code: '&#129001;' },
    { emoji: '💜', code: '&#128999;' },
    { emoji: '🖤', code: '&#128420;' },
    { emoji: '💔', code: '&#128148;' },
    { emoji: '❣️', code: '&#10083;' },
    { emoji: '💕', code: '&#128149;' },
    { emoji: '💞', code: '&#128158;' },
    { emoji: '💓', code: '&#128147;' },

    // ✨ Misc
    { emoji: '✨', code: '&#10024;' },
    { emoji: '🔥', code: '&#128293;' },
    { emoji: '🌟', code: '&#127775;' },
    { emoji: '🎉', code: '&#127881;' },
    { emoji: '🎊', code: '&#127882;' },
    { emoji: '🎁', code: '&#127873;' },
];



// WEBPACK FOOTER //
// ./src/utils/Emoji.js